const ɵ0 = {
    n: 'id',
    t: 'number|string'
};
/** Session Definition */
export const SessionD = {
    recordTypeName: 'Session',
    id: ɵ0,
    name: {
        n: 'name',
        t: 'string'
    },
    label: {
        n: 'label',
        t: 'string'
    },
    description: {
        n: 'description',
        t: 'string'
    },
    isActive: {
        n: 'isActive',
        t: 'boolean',
        d: true
    },
    created: {
        n: 'created',
        t: 'number'
    },
    createdBy: {
        n: 'createdBy',
        t: 'TenantUserI'
    },
    createdById: {
        n: 'createdById',
        t: 'number|string'
    },
    updated: {
        n: 'updated',
        t: 'number'
    },
    updatedBy: {
        n: 'updatedBy',
        t: 'TenantUserI'
    },
    updatedById: {
        n: 'updatedById',
        t: 'number|string'
    },
    externalId: {
        n: 'externalId',
        t: 'string'
    },
    tenant: {
        n: 'tenant',
        t: 'TenantI'
    },
    tenantId: {
        n: 'tenantId',
        t: 'number|string'
    },
    owner: {
        n: 'owner',
        t: 'TenantUserI'
    },
    ownerId: {
        n: 'ownerId',
        t: 'number|string'
    },
    version: {
        n: 'version',
        t: 'number'
    },
    sfId: {
        n: 'sfId',
        t: 'string'
    },
    cid: {
        n: 'cid',
        t: 'string'
    },
    locale: {
        n: 'locale',
        t: 'string'
    },
    utcOffset: {
        n: 'utcOffset',
        t: 'number'
    },
    timezone: {
        n: 'timezone',
        t: 'string'
    },
    language: {
        n: 'language',
        t: 'string'
    },
    tenantUser: {
        n: 'tenantUser',
        t: 'TenantUserI'
    },
    tenantUserId: {
        n: 'tenantUserId',
        t: 'number|string'
    },
    sfOrgId: {
        n: 'sfOrgId',
        t: 'string'
    },
    sfUserId: {
        n: 'sfUserId',
        t: 'string'
    },
    sfUserName: {
        n: 'sfUserName',
        t: 'string'
    },
    sfResourceId: {
        n: 'sfResourceId',
        t: 'string'
    },
    sfInstanceUrl: {
        n: 'sfInstanceUrl',
        t: 'string'
    },
    email: {
        n: 'email',
        t: 'string'
    },
    userName: {
        n: 'userName',
        t: 'string'
    },
    userInitials: {
        n: 'userInitials',
        t: 'string'
    },
    userPhotoUrl: {
        n: 'userPhotoUrl',
        t: 'string'
    },
    firstDayOfWeek: {
        n: 'firstDayOfWeek',
        t: 'number'
    },
    settings: {
        n: 'settings',
        t: '{ [key: string]: string }'
    },
}; // Session
export { ɵ0 };
